import isEmpty from 'validator/lib/isEmpty';
import isInt from 'validator/lib/isInt';

const alarmConfig = {
  machinesId: {
    type: Array,
    required: true,
    validate: {
      message: 'alarmsConfig.atleast-one-machine',
      validator: ids => ids.length > 0,
    },
  },
  yellowConfig: {
    value: {
      type: String,
      required: true,
      validate: {
        message: 'alarmsConfig.time-empty-yellow',
        validator: value => !isEmpty(value) && isInt(value),
      },
    },
  },
  redConfig: {
    value: {
      type: String,
      required: true,
      validate: {
        message: 'alarmsConfig.time-empty-red',
        validator: value => !isEmpty(value) && isInt(value),
      },
    },
  },
};

export default alarmConfig;



// WEBPACK FOOTER //
// ./src/schemas/alarmConfig.js